import {Component, inject, input, OnInit} from '@angular/core'
import {FormGroup, ReactiveFormsModule} from '@angular/forms'
import {
  MatError,
  MatFormField,
  MatLabel,
  MatSuffix
} from '@angular/material/form-field'
import {MatIcon} from '@angular/material/icon'
import {MatOption, MatSelect} from '@angular/material/select'
import {SPBConstants} from '@sparbanken-syd/sparbanken-syd-theme'
import {OrientationService} from '../../../services/orientation.service'
import {RouteService} from '../../../services/route.service'


@Component({
  selector: 'spb-primary-residence',
  templateUrl: './primary-residence.component.html',
  styleUrl: '../kyc.component.scss',
  imports: [ReactiveFormsModule, MatFormField, MatLabel, MatSelect, MatOption, MatError, MatIcon, MatSuffix]
})
export class PrimaryResidenceComponent implements OnInit {
  public primaryResidenceForm = input.required<FormGroup>()
  protected readonly countryList = [...SPBConstants.CountryList]
    .toSorted(a => a.name === 'Sverige' ? -1 : 1)

  protected readonly orientationService = inject(OrientationService)
  private readonly routeService = inject(RouteService)

  public ngOnInit() {
    if (this.routeService.onHorseRoute()) {
      this.prefillSweden()
    }
  }


  private prefillSweden() {
    const form = this.primaryResidenceForm()
    const control = form.get('primaryResidence')
    if (control && !control.value) {
      control.setValue('Sverige')
    }

  }
}
